import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Scale } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { translations } from '../data/translations';

export default function Legal({ type, lang }) {
    const t = (key) => translations[lang][key] || key;

    const contentKey = type === 'privacy' ? 'privacyContent' : 'termsContent';
    const titleKey = type === 'privacy' ? 'privacy' : 'terms';

    return (
        <>
            <Helmet>
                <title>{t(titleKey)} - EveryTool.pro</title>
                <meta name="robots" content="noindex" />
            </Helmet>

            <div className="max-w-3xl mx-auto space-y-8 animate-in fade-in duration-500">
                <div className="bg-white rounded-[3rem] border border-slate-200 p-12 shadow-xl">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="p-4 bg-blue-100 text-blue-600 rounded-2xl">
                            {type === 'privacy' ? <ShieldCheck size={32} /> : <Scale size={32} />}
                        </div>
                        <h1 className="text-3xl font-black">{t(titleKey)}</h1>
                    </div>
                    <div className="prose prose-slate max-w-none">
                        <p className="text-lg text-slate-600 leading-relaxed font-medium">{t(contentKey)}</p>
                    </div>
                </div>
                <Link to={`/${lang}`} className="mx-auto block w-fit font-bold text-blue-600">← {t('home')}</Link>
            </div>
        </>
    );
}
